import React from 'react';
import { Link } from 'react-router-dom';
import SevenDays from '../images/7DaysWIP.gif';
import GameBackground from '../images/7DaysBackground.png'
import JoinDiscord from '../images/JoinDiscord.gif'
import ScrollToTop from './ScrollToTop';
import './SevenDays.css';

const SevenDaysPage = () => {
  return (
    <div className="sevendays-page">
      <ScrollToTop />
      <div className="sevendays-background">
        <img className='game-background' src={GameBackground} alt='game background' />
        <div className="floating-particles"></div>
        <div className="grid-pattern"></div>
      </div>
      
      <div className='sevendays-container'>
        {/* Game Showcase Section */}
        <section className="game-showcase">
          <div className="showcase-content">
            <img className='sevendays-logo' src={SevenDays} alt='Seven Days WIP'></img>
            <h5 className='game-subtitle'>A game by IC Industries</h5>
            <p className='game-description'>
              Discover the strange world you've entered and embrace your traumas and regrets with a hand-drawn art style, atmospheric music, and a creative vision.
              <br /> <br />
              Step into a world where dreams and reality intertwine. Play as a boy caught between wakefulness and dreaming as he explores his daily memories. Each day uncovers a new 
              aspect of his life, from school and family to love and loss. Your choices will shape whether he finds hope, awakens, or descends into darkness. Immerse yourself in unique 
              environments, soothing music, and an emotional story in this captivating adventure.
            </p>
          </div>
        </section>

        {/* Media Section */}
        <section className="media-section">
          <div className="media-grid">
            <div className="media-item">
              <iframe 
                className='youtube-embed' 
                width="100%" 
                height="315" 
                src="https://www.youtube.com/embed/IhwruMIFttI" 
                title="7 Days Early Gameplay Trailer" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerPolicy="strict-origin-when-cross-origin" 
                allowFullScreen>
              </iframe>
            </div>
            
            <div className="media-item">
              <iframe 
                className='youtube-embed' 
                width="100%" 
                height="315" 
                src="https://www.youtube.com/embed/z_RdkjcbUXY?si=9or9VqKlMjMLFSIo" 
                title="YouTube video player" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerPolicy="strict-origin-when-cross-origin" 
                allowFullScreen>
              </iframe>
            </div>
            
            <div className="media-item">
              <iframe 
                className="spotify-embed" 
                title='IC Industries Spotify' 
                src="https://open.spotify.com/embed/artist/4kUyfSyQVgBIgX9nMlFIV5?utm_source=generator" 
                width="100%" 
                height="500" 
                frameBorder="0" 
                allowFullScreen="" 
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
                loading="lazy">
              </iframe>
            </div>
          </div>
        </section>

        {/* Discord Section */}
        <section className="discord-section">
          <div className="discord-content">
            <a href="https://discord.gg/bAT7S5NZZ5" target='_blank' rel='noreferrer'>
              <img className='discord-image' src={JoinDiscord} alt='Join our Discord'></img>
            </a>
            <Link 
              target='_blank' 
              rel='noreferrer' 
              to="https://discord.gg/bAT7S5NZZ5" 
              className="discord-button"
            >
              Join Us
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SevenDaysPage;